export const environment = {
  production: true,
  pageData: 'rcx-p-data'
};
